import { request } from './api';

export const getRegionSiteNames = (options) => request.get('/rei/upload/sites', options);
export const getTurbineTypes = (options) => request.get('/rei/upload/turbine-types', options);
export const getTurbineDetailForSiteId = (siteid, options) =>
  request.get(`/rei/upload/sites/${siteid}/turbines`, options);
export const getComponentDetailList = (turbineAssetId, options) =>
  request.get(`/rei/upload/turbines/${turbineAssetId}/components`, options);
export const getRocStations = (options) => request.get('/rock-station', options);
